export default __webpack_public_path__ + "static/media/dyed-brooms.4684334b.jpg";